import { useSelector } from 'react-redux';
import { getCases } from '../ducks';

export const useGetCases = () => {
  const { data, isLoading, isLoaded } = useSelector(getCases);

  return { casesData: data, isLoading, isLoaded };
};
